'use client'

import { Button } from '@vinted/web-ui'

import { MAX_FACETED_ITEMS_COUNT } from '@marketplace-web/catalog/catalog-data'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  totalItemsCount?: number | null
  maxItemsCount?: number | null
  isAsync?: boolean
  isGoBack?: boolean
  hideItemCount?: boolean
  onSubmit?: () => void
  onGoBack?: () => void
}

const FilterSelectionButton = ({
  totalItemsCount,
  maxItemsCount,
  isAsync,
  isGoBack,
  hideItemCount,
  onSubmit,
  onGoBack,
}: Props) => {
  const translate = useTranslate('catalog.filters.mobile.filters_screen.actions')
  const {
    state: {
      dynamicFilters: {
        filterFacets: { filterFacetsCountMax },
      },
    },
  } = useCatalogContext()

  let submitButtonText = ''
  const showResultText = translate('show_results')
  const goBackText = translate('back')

  if (isGoBack) {
    submitButtonText = goBackText
  } else {
    const totalFactedItemsCount =
      (isAsync ? filterFacetsCountMax : maxItemsCount) || MAX_FACETED_ITEMS_COUNT

    if (hideItemCount || totalItemsCount === null || totalItemsCount === undefined) {
      submitButtonText = showResultText
    } else if (totalItemsCount >= totalFactedItemsCount) {
      submitButtonText = `${showResultText} (${totalFactedItemsCount}+)`
    } else {
      submitButtonText = `${showResultText} (${totalItemsCount})`
    }
  }

  return (
    <div className="u-ui-padding-medium">
      <Button
        onClick={isGoBack ? onGoBack : onSubmit}
        theme="primary"
        text={submitButtonText}
        styling="filled"
        testId="filter-selection-button"
      />
    </div>
  )
}

export default FilterSelectionButton
